/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { SubCategoryDtoName } from './subCategoryDtoName';
import type { SubCategoryDtoCategoryOfTest } from './subCategoryDtoCategoryOfTest';
import type { ChildFamilyDto } from './childFamilyDto';

export interface SubCategoryDto {
  /** Sub category code */
  code: string;
  /** Sub category name (multilingual) */
  name: SubCategoryDtoName;
  /** Category of test */
  categoryOfTest: SubCategoryDtoCategoryOfTest;
  /** Families associated with this sub category */
  families?: ChildFamilyDto[];
}
